/* =====================================================================
   Mobile carousel pagination dots
   ---------------------------------------------------------------------
   Auto-builds the `.carousel-dots` indicator (already styled in
   style.css) for any horizontal scroll-snap carousel marked with
   `data-carousel`. Page-based: one dot per viewport-width of content
   (matches the HTML reference — e.g. 5 origin cards shown 2-at-a-time
   produce 3 dots). Dots update on scroll, navigate on click, and the
   whole thing is hidden by CSS on desktop where the track wraps instead
   of scrolling. Existing slider/scroll behaviour is left untouched.
   ===================================================================== */
(function () {
  'use strict';

  function pageCount(track) {
    var w = track.clientWidth;
    if (!w) return 1;
    var maxScroll = track.scrollWidth - w;
    if (maxScroll <= 1) return 1;
    // Pages are one viewport-width apart and the final page snaps to the very
    // end (maxScroll), so the last page ALWAYS gets its own dot — even when it
    // is only partially full. (Plain round(scrollWidth / w) dropped that final
    // partial page, which is what left the Featured Collection a dot short.)
    // The -0.001 guards against an exact division being bumped up by sub-pixel
    // float noise.
    return Math.ceil(maxScroll / w - 0.001) + 1;
  }

  function update(track, dots) {
    var n = dots.children.length;
    if (!n) return;
    var w = track.clientWidth || 1;
    var maxScroll = track.scrollWidth - w;
    var idx;
    // When scrolled to (or within 1px of) the end, always light the last dot —
    // otherwise the final partial page would never read as active.
    if (track.scrollLeft >= maxScroll - 1) {
      idx = n - 1;
    } else {
      idx = Math.round(track.scrollLeft / w);
    }
    if (idx < 0) idx = 0;
    if (idx > n - 1) idx = n - 1;
    for (var i = 0; i < n; i++) {
      dots.children[i].classList.toggle('is-active', i === idx);
    }
  }

  function build(track, dots) {
    if (!track.clientWidth) return;
    var n = pageCount(track);

    // No overflow (e.g. desktop wrap layout) — nothing to paginate.
    if (n <= 1) {
      dots.style.display = 'none';
      dots.innerHTML = '';
      return;
    }
    dots.style.display = ''; // let the stylesheet decide (mobile flex / desktop none)

    if (dots.children.length !== n) {
      dots.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'carousel-dots__dot';
        b.dataset.index = i;
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dots.appendChild(b);
      }
    }
    update(track, dots);
  }

  function init(track) {
    if (track.dataset.carouselInit === 'true') return;
    track.dataset.carouselInit = 'true';

    var dots = document.createElement('div');
    dots.className = 'carousel-dots';
    track.insertAdjacentElement('afterend', dots);

    dots.addEventListener('click', function (e) {
      var dot = e.target.closest('.carousel-dots__dot');
      if (!dot) return;
      var i = parseInt(dot.dataset.index, 10) || 0;
      var maxScroll = track.scrollWidth - track.clientWidth;
      // The last dot lands on the very end so the final (partial) slide is
      // always reachable; earlier dots align to their page start.
      var left = (i >= dots.children.length - 1) ? maxScroll : i * track.clientWidth;
      try {
        track.scrollTo({ left: left, behavior: 'smooth' });
      } catch (err) {
        // Older Safari: options form unsupported — fall back to an instant jump.
        track.scrollLeft = left;
      }
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update(track, dots);
        ticking = false;
      });
    }, { passive: true });

    var rebuildTimer;
    function rebuild() { build(track, dots); }
    function scheduleRebuild() {
      clearTimeout(rebuildTimer);
      rebuildTimer = setTimeout(rebuild, 200);
    }

    window.addEventListener('resize', scheduleRebuild);
    // Images loading in can change scrollWidth after first paint.
    window.addEventListener('load', rebuild);
    if (window.ResizeObserver) {
      new ResizeObserver(scheduleRebuild).observe(track);
    }

    build(track, dots);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var tracks = scope.querySelectorAll('[data-carousel]');
    for (var i = 0; i < tracks.length; i++) init(tracks[i]);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }

  // Theme editor: rebuild when a section is added / reordered.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
